import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import { track } from "@/lib/track";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); track("page_view", "", pathname); }, [pathname]);

  return (
    <div className="min-h-screen bg-av-black flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

// Shared internal page hero with breadcrumb.
export function PageHero({ overline, title, subtitle, breadcrumb }) {
  return (
    <section className="relative bg-av-deep grain pt-36 pb-16 sm:pb-20 border-b border-white/10">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 sm:px-8">
        {breadcrumb && (
          <nav className="text-xs text-av-gray mb-6" aria-label="Breadcrumb">
            {breadcrumb}
          </nav>
        )}
        {overline && <p className="overline text-av-bright mb-4">{overline}</p>}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-av-white max-w-4xl text-balance">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-av-gray text-base sm:text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
